import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DeleteLandingPageLocationModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteLandingPageLocationModalContainer" */
      './DeleteLandingPageLocationModalContainer'
    ),
  loading: LoadingModal,
});
